import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import SuperColumn from "../super-column"

const SuperGrid = ({ blok }) => (
  <SbEditable content={blok}>
    <div className={`super-grid ${blok.reverse ? "super-grid--reverse" : ""}`}>
      {blok.super_columns &&
        blok.super_columns.map((col, idx) => (
          <SuperColumn key={col._uid} blok={col} />
        ))}
    </div>
  </SbEditable>
)

SuperGrid.propTypes = {
  blok: PropTypes.shape({
    super_columns: PropTypes.arrayOf(PropTypes.object),
    reverse: PropTypes.bool,
  }).isRequired,
}

export default SuperGrid
